module.exports = __webpack_public_path__ + "static/bnp-644edbca12091538912072e4d7e7eb6e.png";